import { createContext, useContext, useEffect, useState } from 'react'

import { API } from '@/api'
import { ServerDomainInfo } from '@/api/type-server'
import { useUserStore } from '@/stores/user'

interface DomainContextType {
  domainInfos: ServerDomainInfo[]
  loading: boolean
}

const DomainContext = createContext<DomainContextType>({
  domainInfos: [],
  loading: true,
})

export function DomainProvider({ children }: { children: React.ReactNode }) {
  const userId = useUserStore((state) => state.id)
  const [domainInfos, setDomainInfos] = useState<ServerDomainInfo[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (userId <= 0) {
      setDomainInfos([])
      setLoading(false)
      return
    }

    const fetchDomains = async () => {
      setLoading(true)
      try {
        const res = await API.getDomainList()
        if (res.code === 0) {
          setDomainInfos(res.domainInfos || [])
        }
      } catch (error) {
        console.error('Failed to fetch domains:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchDomains()
  }, [userId])

  return (
    <DomainContext.Provider value={{ domainInfos, loading }}>{children}</DomainContext.Provider>
  )
}

export const useDomain = () => useContext(DomainContext)
